module.exports = __webpack_public_path__ + "static/media/course-2.cd02f446.jpg";